import React from 'react';
import { Card, Form, InputGroup } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle, faSearch, faTimes } from '@fortawesome/pro-solid-svg-icons';

interface Item {
  id: number;
  name?: string;
  userNames?: string[];
}

interface GenericListProps {
  emptyText: string;
  items: Item[];
  loading: boolean;
  searchText: string;
  renderItemLabel: (item: Item) => React.ReactNode;
  onAddItem?: (id: number) => void;
  onRemoveItem?: (id: number) => void;
  onSetSearchText: (text: string) => void;
}

export default function GenericList({
  emptyText,
  items,
  loading,
  searchText,
  renderItemLabel,
  onAddItem,
  onRemoveItem,
  onSetSearchText,
}: GenericListProps) {  
  return (
    <div>
      <Form.Group className="mb-3">
        <InputGroup>
          <InputGroup.Text className="text-primary">
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search"
            type="text"
            value={searchText}
            onChange={e => onSetSearchText(e.target.value)}
          />
          <button
            aria-label="Clear search"
            className="btn btn-outline-secondary"
            disabled={!searchText}
            type="button"
            onClick={() => onSetSearchText('')}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </InputGroup>
      </Form.Group>
      <Card className="overflow-auto" style={{ height: 300 }}>
        {items?.length > 0 ? (
          <ul className="list-group list-group-flush">
            {items.map((item: Item) => (
              <li className="list-group-item d-flex align-items-center" key={item.id}>
                <div className="flex-grow-1 d-flex" style={{ minWidth: 0 }}>
                  <div className="text-truncate">
                    {renderItemLabel(item)}
                  </div>
                </div>
                {onAddItem && (
                  <div className="ms-auto pe-2 d-inline-flex align-items-center">
                    {loading ? (
                      <span aria-label="Loading" className="spinner-border" role="status" />
                    ) : (
                      <FontAwesomeIcon
                        className="text-success clickable"
                        icon={faPlusCircle}
                        name="add-team"
                        onClick={() => onAddItem(item.id)}
                      />
                    )}
                  </div>
                )}
                {onRemoveItem && (
                  <div className="ms-auto pe-2 d-inline-flex align-items-center">
                    {loading ? (
                      <span aria-label="Loading" className="spinner-border" role="status" />
                    ) : (
                      <FontAwesomeIcon
                        className="text-danger clickable"
                        icon={faMinusCircle}
                        name="remove-team"
                        onClick={() => onRemoveItem(item.id)}
                      />
                    )}
                  </div>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <div className="d-flex h-100 align-items-center justify-content-center">
            <h5 className="text-muted text-center m-0">
              {emptyText}
            </h5>
          </div>
        )}
      </Card>
    </div>
  );
}
